export enum GetSuggestAreaModeEnum {
    Prefecture = 'prefecture',
    Town = 'town',
    Street = 'street',
    Station = 'station',
    Busstop = 'busstop',
}